import i from "./eq.js";
import m from "./isArrayLike.js";
import a from "./_isIndex.js";
import s from "./isObject.js";
function u(f, t, r) {
  if (!s(r))
    return !1;
  var e = typeof t;
  return (e == "number" ? m(r) && a(t, r.length) : e == "string" && t in r) ? i(r[t], f) : !1;
}
export {
  u as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_isIterateeCall.js
// module id = 1525
// module chunks = 67